import { useEffect, useState } from "react";
import { API, BACKEND, fmtTgl, fmtWaktu, pesanGalat } from "../lib/api";
import { useAuth } from "../auth";
import Shell from "../components/Shell";
import TanggalPilihan from "../components/TanggalPilihan";
import { JudulHalaman, KerangkaBaris, KeadaanGalat, StatusMark, KELAS_TABEL, KELAS_TH, KELAS_TD, KELAS_TR, useTabelKeys } from "../components/kit";

export default function Pamit() {
  const { user } = useAuth();
  const [orang, setOrang] = useState(null);
  const [galat, setGalat] = useState(null);
  const [pilih, setPilih] = useState(null);
  const [ringkasan, setRingkasan] = useState(null);
  const [tanggal, setTanggal] = useState(new Date().toISOString().slice(0, 10));
  const [pesan, setPesan] = useState(null);

  const muat = () => {
    setGalat(null);
    API.get("/orang").then((r) => setOrang(r.data)).catch((e) => setGalat(pesanGalat(e)));
  };
  useEffect(muat, []);

  const buka = async (o) => {
    setPilih(o); setRingkasan(null); setPesan(null);
    try {
      const r = await API.get(`/orang/${o.id}/ringkasan`);
      setRingkasan(r.data);
    } catch (e) { setPesan(pesanGalat(e)); }
  };
  const ref = useTabelKeys((id) => buka(orang.find((o) => o.id === id)));

  const tandaiKeluar = async () => {
    try {
      const r = await API.put(`/orang/${pilih.id}/keluar`, { tanggal_keluar: new Date(tanggal).toISOString() });
      const segar = { ...pilih, status: "keluar", tanggal_keluar: new Date(tanggal).toISOString() };
      setPilih(segar);
      const rk = await API.get(`/orang/${pilih.id}/ringkasan`);
      setRingkasan(rk.data);
      setPesan(`${r.data.baris_tutup_dibuat} baris TUTUP otomatis dibuat dan diteruskan ke pemilik akses.`);
      muat();
    } catch (e) { setPesan(pesanGalat(e)); }
  };

  return (
    <Shell>
      <div className="relative border mb-6 overflow-hidden">
        <img src="https://images.unsplash.com/photo-1559582284-9e0e40585af4" alt="" aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover opacity-20 dark:opacity-10" />
        <div className="relative p-6">
          <JudulHalaman testid="judul-pamit" judul="Pamit"
            sub="Pilih hari kerja terakhir seseorang. PAM-IT membuat catatan TUTUP untuk setiap akses yang masih aktif." />
        </div>
      </div>
      {galat && <KeadaanGalat testid="galat-pamit" pesan={galat} onCoba={muat} />}
      {!orang && !galat && <KerangkaBaris testid="memuat-pamit" n={5} />}
      {orang && (
        <div ref={ref} className="overflow-x-auto border" aria-label="Daftar orang — panah untuk berpindah, Enter membuka">
          <table className={KELAS_TABEL} data-testid="tabel-orang">
            <thead>
              <tr>
                <th className={KELAS_TH}>Kode</th><th className={KELAS_TH}>Nama (samaran)</th>
                <th className={KELAS_TH}>Departemen</th><th className={KELAS_TH}>Status</th><th className={KELAS_TH}>Tanggal keluar</th>
              </tr>
            </thead>
            <tbody>
              {orang.map((o) => (
                <tr key={o.id} data-row={o.id} tabIndex={-1} data-testid={`orang-${o.kode}`} onClick={() => buka(o)} className={KELAS_TR}>
                  <td className={`${KELAS_TD} font-data`}>{o.kode}</td>
                  <td className={KELAS_TD}>{o.nama_tampil}</td>
                  <td className={KELAS_TD}>{o.departemen}</td>
                  <td className={KELAS_TD}>
                    {o.status === "aktif"
                      ? <span className="text-xs font-medium">AKTIF</span>
                      : <span className="text-xs font-medium text-red-600 dark:text-red-400">KELUAR</span>}
                  </td>
                  <td className={`${KELAS_TD} font-data text-xs`}>{fmtTgl(o.tanggal_keluar)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {pilih && (
        <aside data-testid="panel-pamit" className="fixed inset-y-0 right-0 w-full max-w-md bg-background border-l p-6 overflow-y-auto z-30">
          <button data-testid="tutup-panel-pamit" onClick={() => setPilih(null)} className="text-sm underline mb-4">Tutup</button>
          <h2 className="font-heading text-xl font-semibold">{pilih.nama_tampil} <span className="font-data text-base text-muted-foreground">{pilih.kode}</span></h2>
          {pesan && <p className="mt-3 text-sm border p-2" data-testid="pesan-pamit">{pesan}</p>}
          {pilih.status === "aktif" && (
            <div className="mt-4 border p-3">
              <label className="text-xs font-medium uppercase tracking-wide" htmlFor="tgl-keluar">Hari kerja terakhir</label>
              <TanggalPilihan
                id="tgl-keluar"
                label="Hari kerja terakhir"
                nilai={tanggal}
                onUbah={setTanggal}
                testid="input-tanggal-keluar"
              />
              <button data-testid="btn-tandai-keluar" onClick={tandaiKeluar}
                className="mt-2 w-full px-3 py-2 bg-primary text-primary-foreground text-sm font-medium transition-colors duration-150 hover:opacity-90">
                Tandai keluar dan buat catatan TUTUP
              </button>
            </div>
          )}
          {ringkasan && (
            <div className="mt-4">
              <h3 className="text-xs font-medium uppercase tracking-wide text-muted-foreground mb-2">Status di setiap akses</h3>
              <ul className="space-y-1" data-testid="ringkasan-penutupan">
                {ringkasan.akses.length === 0 && <li className="text-sm text-muted-foreground italic">Tidak ada akses tercatat.</li>}
                {ringkasan.akses.map((a, i) => (
                  <li key={i} className="flex items-center justify-between border-b pb-1 text-sm">
                    <span>{a.sistem}</span>
                    <StatusMark status={a.keadaan === "tertutup" ? "TERTUTUP" : a.keadaan === "tak_bertuan" ? "TAK_BERTUAN" : "TERBUKA"} testid={`status-pamit-${a.keadaan}`} />
                  </li>
                ))}
              </ul>
              {ringkasan.surat && (
                <div className="mt-4 border-2 border-emerald-600 p-3" data-testid="surat-terbit">
                  <p className="text-sm font-medium text-emerald-600 dark:text-emerald-400">Surat Keterangan Bebas Akses terbit</p>
                  <p className="font-data text-sm mt-1">{ringkasan.surat.nomor} — {fmtWaktu(ringkasan.surat.diterbitkan_pada)}</p>
                  {user?.peran === "admin" && ringkasan.surat_admin && (
                    <a data-testid="tautan-pdf-surat" href={`${BACKEND}/api/surat/pdf/${ringkasan.surat_admin.token}`} target="_blank" rel="noreferrer"
                      className="text-sm underline mt-1 inline-block">Unduh PDF</a>
                  )}
                </div>
              )}
            </div>
          )}
        </aside>
      )}
    </Shell>
  );
}
